<template>
  <div class="mt-4">
    <h4>{{ $t('ct-checkout-form-config') }}</h4>
    <p class="col-xs-12 col-sm-8 pl-1">
      {{ $t('ct-checkout-form-config-info') }}
    </p>

    <div class="form-group row">
      <div class="row ml-4 mb-4">
        <button class="btn btn-xs" :class="{'btn-primary': config.steps === 1, 'btn-outline-primary': config.steps !== 1}" type="button" @click="config.steps = 1">1 step</button>
        <button class="btn btn-xs" :class="{'btn-primary': config.steps === 2, 'btn-outline-primary': config.steps !== 2}" type="button" @click="config.steps = 2">2 step</button>
        <button class="btn btn-xs" :class="{'btn-primary': config.steps === 3, 'btn-outline-primary': config.steps !== 3}" type="button" @click="config.steps = 3">3 step</button>
      </div>
      <theme-selector v-if="config" class="col-sm-12" :config="config"/>
    </div>

    <texts-onestep-config v-if="config.steps === 1" :config="config" :e="e" @save="$emit('done')" @cancel="cancel"/>
    <texts-twostep-config v-if="config.steps === 2" :config="config" :e="e" @save="$emit('done')" @cancel="cancel"/>
    <texts-threestep-config v-if="config.steps === 3" :config="config" :e="e" @save="$emit('done')" @cancel="cancel"/>

  </div>
</template>

<script>
import Errors from '../Util/errors';
import ThemeSelector from './CheckoutThemeSelector';
import TextsOnestepConfig from './TextsOnestepConfig';
import TextsTwostepConfig from './TextsTwostepConfig';
import TextsThreestepConfig from './TextsThreestepConfig';

export default {
  name: 'CheckoutFormConfig',
  props: ['config'],
  components: {ThemeSelector, TextsOnestepConfig, TextsTwostepConfig, TextsThreestepConfig},
  data: vm => ({
    e: new Errors([])
  }),
  watch: {
    config: {
      deep: true,
      handler(config) {
        this.$emit('input', config);
      }
    }
  },

  methods: {
    cancel() {
      this.config.sellableHash = '';
      this.config.type = '';
    }
  },

  beforeDestroy() {
    this.e.clear();
  }
};
</script>

<style scoped>
.btn-xs {
  padding: 5px 10px !important;
  min-height: 1rem !important;
  border-radius: 3px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/FormConfig.vue